module.exports = __webpack_public_path__ + "fonts/95ea534a-2fc2-4365-9df6-5530cbc58cdf.1ec718b.woff2";